import React from 'react'

export default function TypeShort({ questiondata, setQuestionData }: any): JSX.Element {
    return (
        <div>
            <h5>Los alumnos responderán la pregunta de manera consisa.(80 palabras)</h5>
        </div>
    )
}
